// src/pages/QR.js
import React, { useState, useEffect } from 'react';
import { Typography, Box, CircularProgress } from '@mui/material';
import { QRCodeCanvas } from 'qrcode.react';

function QR() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (window.Pi) {
      // Authenticate the user (if already authenticated, this should return immediately)
      const scopes = ['username'];
      window.Pi.authenticate(scopes, (payment) => {
        console.log("Incomplete payment found:", payment);
      })
        .then((auth) => {
          // Expected auth.user to have properties like uid and username
          setUser(auth.user);
        })
        .catch((error) => {
          console.error("Authentication error:", error);
        });
    } else {
      console.error("Pi SDK not found. Please ensure the SDK script is included in index.html.");
    }
  }, []);

  if (!user) {
    return (
      <Box textAlign="center" mt={4}>
        <CircularProgress />
        <Typography variant="body1">Loading user details...</Typography>
      </Box>
    );
  }

  // Use the authenticated user's details for the QR code payload.
  const qrData = JSON.stringify({
    receiverId: user.uid,
    receiverName: user.username,
    type: "paymentReceiver"
  });

  return (
    <Box textAlign="center" mt={4}>
      <Typography variant="h4" gutterBottom>
        Your QR Code
      </Typography>
      <Typography variant="body1" gutterBottom>
        Share this code so that others can scan and send you payments.
      </Typography>
      <Box sx={{ margin: '1rem auto', width: 256 }}>
        <QRCodeCanvas value={qrData} size={256} />
      </Box>
    </Box>
  );
}

export default QR;
